import React from 'react';
import cx from 'classnames/bind';
import PropTypes from 'prop-types';

function FormFeedback({ isInvalid, errorMessage, className }) {
    return (
        isInvalid && (
            <div
                className={cx(className)}
                style={{
                    width: '100%',
                    marginTop: '0.25rem',
                    fontSize: '80%',
                    color: '#dc3545',
                }}
            >
                {errorMessage}
            </div>
        )
    );
}
FormFeedback.defaultProps = {
    errorMessage: '',
    className: '',
};
FormFeedback.propTypes = {
    isInvalid: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
};
export default FormFeedback;
